/* Mobile menu burger toggle */
(function () {
    const navigation = document.querySelector('.gh-navigation');
    const burger = navigation?.querySelector('.gh-burger');
    if (!burger) return;

    const setOpen = function (open) {
        navigation.classList.toggle('is-open', open);
        burger.setAttribute('aria-expanded', String(open));
        document.querySelectorAll('#main-content, .gh-footer').forEach(function (element) {
            element.inert = open;
        });
        document.documentElement.style.overflowY = open ? 'hidden' : '';
    };
    burger.addEventListener('click', function () {
        setOpen(!navigation.classList.contains('is-open'));
    });
    navigation.addEventListener('click', function (event) {
        if (event.target.closest('a') && navigation.classList.contains('is-open')) {
            setOpen(false);
        }
    });
    navigation.addEventListener('keydown', function (event) {
        if (event.key === 'Tab' && navigation.classList.contains('is-open')) {
            const focusable = Array.from(navigation.querySelectorAll('a[href], button, input, summary')).filter(function (element) {
                return !element.disabled && element.getClientRects().length > 0;
            });
            const first = focusable[0];
            const last = focusable[focusable.length - 1];
            if (event.shiftKey && document.activeElement === first) {
                event.preventDefault();
                last.focus();
            } else if (!event.shiftKey && document.activeElement === last) {
                event.preventDefault();
                first.focus();
            }
        }
        if (event.key === 'Escape' && navigation.classList.contains('is-open')) {
            setOpen(false);
            burger.focus();
        }
    });
    window.matchMedia('(min-width: 768px)').addEventListener('change', function (event) {
        if (event.matches) setOpen(false);
    });
})();

/* Add lightbox to gallery and feature images */
(function () {
    lightbox(
        '.kg-image-card > .kg-image[width][height], .kg-gallery-image > img, .gh-feature-image'
    );
})();

/* Responsive video in post content */
(function () {
    const sources = [
        '.gh-content iframe[src*="youtube.com"]',
        '.gh-content iframe[src*="youtube-nocookie.com"]',
        '.gh-content iframe[src*="player.vimeo.com"]',
        '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
        '.gh-content object',
        '.gh-content embed',
    ];
    reframe(document.querySelectorAll(sources.join(',')));
})();

/* Enhance the configured Games link; without JS it remains a normal link. */
(function () {
    const source = document.querySelector('#studio-games-navigation');
    const navigation = document.querySelector('#navigation-menu');
    if (!source || !navigation) return;
    const label = source.dataset.label;
    const link = Array.from(navigation.querySelectorAll('.nav > li > a')).find(function (a) {
        return a.textContent.trim().toLocaleLowerCase() === label.toLocaleLowerCase();
    });
    if (!link) return;
    const details = document.createElement('details');
    details.className = 'studio-games-disclosure';
    const summary = document.createElement('summary');
    summary.textContent = link.textContent;
    details.appendChild(summary);
    details.appendChild(source.content.cloneNode(true));
    link.replaceWith(details);
    // Delegation survives the theme's responsive navigation reconstruction.
    document.addEventListener('click', function (event) {
        document.querySelectorAll('.studio-games-disclosure[open]').forEach(function (item) {
            if (!item.contains(event.target) || event.target.closest('a')) item.open = false;
        });
    });
    const hoverMedia = window.matchMedia('(hover: hover) and (pointer: fine)');
    let closeTimer;
    navigation.addEventListener('pointerover', function (event) {
        const item = event.target.closest('.studio-games-disclosure');
        if (!item || !hoverMedia.matches || event.pointerType === 'touch') return;
        clearTimeout(closeTimer);
        item.open = true;
    });
    navigation.addEventListener('pointerout', function (event) {
        const item = event.target.closest('.studio-games-disclosure');
        if (!item || !hoverMedia.matches || item.contains(event.relatedTarget)) return;
        closeTimer = setTimeout(function () {
            if (!item.contains(document.activeElement)) item.open = false;
        }, 150);
    });
    navigation.addEventListener('keydown', function (event) {
        const item = event.target.closest('.studio-games-disclosure');
        if (!item) return;
        if (event.key === 'Escape' && item.open) {
            event.preventDefault();
            event.stopPropagation();
            item.open = false;
            item.querySelector('summary').focus();
        } else if (event.key === 'ArrowDown' && event.target.tagName === 'SUMMARY') {
            event.preventDefault();
            item.open = true;
            item.querySelector('a').focus();
        }
    });
    navigation.addEventListener('focusout', function (event) {
        const item = event.target.closest('.studio-games-disclosure');
        if (item && !item.contains(event.relatedTarget)) item.open = false;
    });
})();

/* Turn the main nav into dropdown menu when there are more than 5 menu items */
(function () {
    dropdown();
})();

/* Infinite scroll pagination */
(function () {
    if (!document.body.classList.contains('home-template') && !document.body.classList.contains('post-template')) {
        pagination();
    }
})();

/* Responsive HTML table */
(function () {
    const tables = document.querySelectorAll('.gh-content > table:not(.gist table)');
    
    tables.forEach(function (table) {
        const wrapper = document.createElement('div');
        wrapper.className = 'gh-table';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
})();
/* Keep button labels readable when the Ghost accent color changes. */
(function () {
    const hex = getComputedStyle(document.documentElement).getPropertyValue('--ghost-accent-color').trim();
    if (!/^#([a-f\d]{3}|[a-f\d]{6})$/i.test(hex)) return;
    const value = hex.length === 4 ? hex.slice(1).split('').map(function (c) { return c + c; }).join('') : hex.slice(1);
    const rgb = [0, 2, 4].map(function (offset) {
        const channel = parseInt(value.slice(offset, offset + 2), 16) / 255;
        return channel <= 0.04045 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
    });
    const luminance = rgb[0] * 0.2126 + rgb[1] * 0.7152 + rgb[2] * 0.0722;
    document.documentElement.style.setProperty('--studio-button-text', luminance > 0.179 ? '#000' : '#fff');
})();
